import React, { useRef, useState, useEffect } from "react";

// Scales a fixed design-sized canvas (design coords) down to fit its parent width.
// Guarantees pixel-accurate proportional layouts on large screens.
const ScaledStage = ({ width, height, children, className = "" }) => {
  const ref = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () => setScale(el.offsetWidth / width);
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    window.addEventListener("resize", update);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", update);
    };
  }, [width]);

  return (
    <div ref={ref} className={className} style={{ height: height * scale, position: "relative" }}>
      <div style={{ width, height, transform: `scale(${scale})`, transformOrigin: "top left", position: "absolute", top: 0, left: 0 }}>
        {children}
      </div>
    </div>
  );
};

export default ScaledStage;
